import { render, staticRenderFns } from "./UnlockModal.vue?vue&type=template&id=a3630f3c&scoped=true"
import script from "./UnlockModal.vue?vue&type=script&lang=js"
export * from "./UnlockModal.vue?vue&type=script&lang=js"
import style0 from "./UnlockModal.vue?vue&type=style&index=0&id=a3630f3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3630f3c",
  null
  
)

export default component.exports